import { gql } from '@apollo/client';

export const UPSERT_COMMUNITY_GROUP_ACTION = gql`
  mutation UpsertCommunityGroupAction($communityGroupId: ID!, $actionName: String!, $input: UpsertActionInput!) {
    upsertCommunityGroupAction(communityGroupId: $communityGroupId, actionName: $actionName, input: $input) {
      name
      type
      description
      deliveryType
      labels {
        labelId
        severity
      }
      policies
      operatorName
      deliverySettings {
        url
        postPayload
      }
    }
  }
`;
